import {CropSeasonModel} from '../../model/farms/CropSeasonModel.js';
import {BaseCollection} from '../BaseCollection';

/**
 * @class CropSeasonCollection
 * @extends BaseCollection
 */
export class CropSeasonCollection extends BaseCollection {

    get url () {

        return (API_PREFIX + '/farms/crop-seasons');
    }

    get model () {

        return CropSeasonModel;
    }

    static cmpByStartDate (cs1, cs2) {

        let date1 = cs1.get('startDate');
        let date2 = cs2.get('startDate');

        if (moment.isMoment(date1) && moment.isMoment(date2)) {

            if (date1.isAfter(date2)) {
                return -1;
            }
            else if (date1.isBefore(date2)) {
                return 1;
            }

            return 0;
        }

        return 0;
    }
}


// WEBPACK FOOTER //
// ./shared/collection/farms/CropSeasonCollection.js